import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth-context.js';

export function RedirectSuperAdmin() {
  const { userRole, isLoading } = useAuth();

  // Wait for auth to load before deciding
  if (isLoading) return null;

  if (userRole === 'super_admin') {
    return <Navigate to="/admin/orgs" replace />;
  }
  return <Outlet />;
}
